import EditorToolProps from './Tools'

let KendoEditorTool = {
    name: 'kendo-editor-tool',
    render () {
        return null
    },
    mixins: [EditorToolProps]
}

export default KendoEditorTool


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditorTool/index.js